import React from "react";
import { Index } from "react-instantsearch";
import { usePermissions } from "hooks";
import { usePreferences } from "hooks/firestore/v2/user/usePreferences";
import useMustHidePickems from "hooks/useMustHidePickems";
import { NoResultsBoundary } from "./components/NoResultsBoundary";
import { SportsResults } from "./components/SportsResults";
import { MatchResults } from "./components/MatchResults";
import { RacingResults } from "./components/RacingResults";
import { OutrightResults } from "./components/OutrightResults";
import { PageResults } from "./components/PageResults";
import { PickemsResults } from "./components/PickemsResults";

import * as styles from "./Results.module.scss";

const Results = () => {
  const permissions = usePermissions();
  const { preferences } = usePreferences();
  const { defaultHub } = preferences;

  const canViewMatches =
    permissions.viewSportsMarkets === "GRANTED" ||
    permissions.viewEsportsMarkets === "GRANTED";

  const canViewRacing = permissions.viewRacingMarkets === "GRANTED";
  const mustHidePickems = useMustHidePickems();
  const canViewPickems = !mustHidePickems;

  const racing = canViewRacing ? (
    <Index key="races-index" indexName={`races`}>
      <RacingResults />
    </Index>
  ) : null;

  const matches = canViewMatches ? (
    <Index key="matches-index" indexName={`matches`}>
      <MatchResults />
    </Index>
  ) : null;

  const outrights = canViewMatches ? (
    <Index key="outrights-index" indexName={`outrights`}>
      <OutrightResults />
    </Index>
  ) : null;

  const sports = (
    <Index key="sports-index" indexName={`sports`}>
      <SportsResults />
    </Index>
  );

  const pickems = canViewPickems ? (
    <Index key="pickems-index" indexName={`pickems`}>
      <PickemsResults />
    </Index>
  ) : null;

  const pages = (
    <Index key="pages-index" indexName={`pages`}>
      <PageResults />
    </Index>
  );

  const orderedResults = [
    ...(defaultHub === "RACING"
      ? [racing, matches, outrights, sports]
      : [matches, outrights, sports, racing]),
    pickems,
    pages,
  ].filter((el) => !!el);

  return (
    <NoResultsBoundary>
      <div className={styles.resultsContainer}>{orderedResults}</div>
    </NoResultsBoundary>
  );
};

export { Results };
